// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assign-coach-modal .modal-content {
    /* max-height: 500px; */
    min-height: 500px;
}

.assignQuestion-modal-container {
    width: 100%;
    /* max-height: 486px;
    overflow: auto; */
}


.assignQuestion-modal-container form>div:nth-child(1)>div {
    width: 100%;
}

.selected-question-wrapper {
    max-height: 300px;
    overflow: auto;
    /* background: red; */
    padding-right: 10px;
}


.render-selected-question-wrapper {
    display: flex;
    flex-direction: row;
    /* justify-content: space-between; */
    align-items: center;
    border-radius: 15px !important;
    background: var(--field-background) !important;
    border: 1px solid var(--field-background) !important;
    min-height: 50px !important;
    padding: 5px 24px 5px 15px;
    margin-bottom: 15px;
    position: relative;
}


.assignQuestion-modal-container .css-3iigni-container>div:nth-child(2)>div:first-child,
.assignQuestion-modal-container .css-1yhe670-control>div:nth-child(2)>div:first-child {
    display: none !important;
}

.assignQuestion-modal-container .css-3iigni-container>div:nth-child(2)>div:first-child,
.assignQuestion-modal-container .css-1nkf596-control>div:nth-child(2)>div:first-child {
    display: none !important;
}

/* .css-3iigni-container */


.selected-Item {
    width: 14px;
    height: 14px;
    margin-right: 20px;
    border-radius: 50%;
    background-color: var(--inactive-red-text);
    cursor: pointer;
}

.unselected-item {
    width: 14px;
    height: 14px;
    margin-right: 20px;
    border-radius: 50%;
    border: 1px solid var(--active-green-text);
    cursor: pointer;
}

.css-n3rqp9-control {}

.question-cross-icon {
    position: absolute;
    right: 16px;
    top: 13px;
}



/*********************media queries*****************/`, "",{"version":3,"sources":["webpack://./src/components/modals/assignQuestionModal/AssignQuestionModal.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX;qBACiB;AACrB;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,mBAAmB;IACnB,8BAA8B;IAC9B,8CAA8C;IAC9C,oDAAoD;IACpD,2BAA2B;IAC3B,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;;IAEI,wBAAwB;AAC5B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA,0BAA0B;;;AAG1B;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;AACnB;;AAEA,qBAAqB;;AAErB;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;;;AAIA,oDAAoD","sourcesContent":[".assign-coach-modal .modal-content {\n    /* max-height: 500px; */\n    min-height: 500px;\n}\n\n.assignQuestion-modal-container {\n    width: 100%;\n    /* max-height: 486px;\n    overflow: auto; */\n}\n\n\n.assignQuestion-modal-container form>div:nth-child(1)>div {\n    width: 100%;\n}\n\n.selected-question-wrapper {\n    max-height: 300px;\n    overflow: auto;\n    /* background: red; */\n    padding-right: 10px;\n}\n\n\n.render-selected-question-wrapper {\n    display: flex;\n    flex-direction: row;\n    /* justify-content: space-between; */\n    align-items: center;\n    border-radius: 15px !important;\n    background: var(--field-background) !important;\n    border: 1px solid var(--field-background) !important;\n    min-height: 50px !important;\n    padding: 5px 24px 5px 15px;\n    margin-bottom: 15px;\n    position: relative;\n}\n\n\n.assignQuestion-modal-container .css-3iigni-container>div:nth-child(2)>div:first-child,\n.assignQuestion-modal-container .css-1yhe670-control>div:nth-child(2)>div:first-child {\n    display: none !important;\n}\n\n.assignQuestion-modal-container .css-3iigni-container>div:nth-child(2)>div:first-child,\n.assignQuestion-modal-container .css-1nkf596-control>div:nth-child(2)>div:first-child {\n    display: none !important;\n}\n\n/* .css-3iigni-container */\n\n\n.selected-Item {\n    width: 14px;\n    height: 14px;\n    margin-right: 20px;\n    border-radius: 50%;\n    background-color: var(--inactive-red-text);\n    cursor: pointer;\n}\n\n.unselected-item {\n    width: 14px;\n    height: 14px;\n    margin-right: 20px;\n    border-radius: 50%;\n    border: 1px solid var(--active-green-text);\n    cursor: pointer;\n}\n\n.css-n3rqp9-control {}\n\n.question-cross-icon {\n    position: absolute;\n    right: 16px;\n    top: 13px;\n}\n\n\n\n/*********************media queries*****************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
